import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './modules/campaign/landing/landing.component';
import { AdminComponent } from './modules/admin/admin.component';
import { LayoutComponent } from './modules/page-layout/layout/layout.component';
import { FeedbackComponent } from './modules/support/feedback/feedback.component';
import { EmailReminderComponent } from './modules/shared/email-reminder/email-reminder.component';
import { ClickToPlayComponent } from './modules/campaign/click-to-play/click-to-play.component';
import { FeedbackSuccessComponent } from './modules/support/feedback-success/feedback-success.component';
import { CookieComponent } from './modules/support/cookie/cookie.component';
import { RedirectionGuard } from './core/guards/redirection.guard';
import { LoginComponent } from './modules/campaign/login/login.component';
import { ResetPasswordComponent } from './modules/campaign/reset-password/reset-password.component';
import { HeaderComponent } from './modules/page-layout/header/header.component';
import { AppComponent } from './app.component';
import { RewardsListComponent } from './modules/campaign/rewards-list/rewards-list.component';
import { RegisterComponent } from './modules/campaign/register/register.component';
import { ProfileComponent } from './modules/campaign/profile/profile.component';
import { UploadReceiptComponent } from './modules/campaign/upload-receipt/upload-receipt.component';
import { ScanParticipateComponent } from './modules/campaign/scan-participate/scan-participate.component';
import { SuccessComponent } from './modules/campaign/scan-participate/success/success.component';
import { ReportsComponent } from './modules/campaign/reports/reports.component';
import { StripePayComponent } from './modules/campaign/stripe-pay/stripe-pay.component';
import { StripeSuccessComponent } from './modules/campaign/stripe-success/stripe-success.component';
import { ReportsLoginComponent } from './modules/campaign/reports-login/reports-login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { StripeCancelComponent } from './modules/campaign/stripe-cancel/stripe-cancel.component';

const routes: Routes = [

  //Default - Finnish
  { path: '', component: LandingComponent, },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'reminder', component: EmailReminderComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'click-to-play', component: ClickToPlayComponent },
  { path: 'feedback/success', component: FeedbackSuccessComponent },
  { path: 'cookie', component: CookieComponent },
  { path: '*', redirectTo: '' },
  // { path: '**', redirectTo: '' },
  { path: 'login', component: LoginComponent },
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'app', component: AppComponent},
  {path: 'rewards', component: RewardsListComponent},
  { path: 'register', component: RegisterComponent },
  { path: 'upload', component: UploadReceiptComponent },
  { path: 'profile', component: ProfileComponent},
   { path: 'stripe-pay', component: StripePayComponent},
  { path: 'payment-success', component: StripeSuccessComponent},
  { path: 'payment-cancel', component: StripeCancelComponent},
  { path: 'scan-participate', component: ScanParticipateComponent},
  { path: 'scan/success', component: SuccessComponent },
    { path: 'reports', component: ReportsComponent, canActivate:[AuthGuard] },
    { path: 'reports-login', component: ReportsLoginComponent }




  // { path: '', component: LandingComponent, pathMatch: 'full' },
  // { path: 'se', component: LandingSeComponent },
  // { path: 'home/:type', component: HomeComponent },
  // { path: 'play', component: PlayComponent },
  // { path: 'rules', component: RulesComponent },
  // { path: 'feedback', component: FeedbackComponent },
  // { path: 'feedback/success', component: FeedbackSuccessComponent },
  // { path: 'admin', component: AdminComponent },
  // { path: 'upload', component: PlayWithReceiptComponent },
  // { path: '*', redirectTo: '' },
  // { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100] // [x, y]
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
